<div class="fade-in">
  <div class="content-section">
    <div class="section-header">
      <h2>Brand Management</h2>
      <button class="primary-btn" (click)="openAddModal()">+ Add Brand</button>
    </div>

    <!-- Modal Form for Add/Edit -->
    <div class="modal-overlay" *ngIf="isModalOpen">
      <div class="modal-content fade-in" [class.saving-mode]="isSaving">
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
          <h3 class="modal-title" style="margin-bottom: 0;">
            {{ editingId ? 'Edit Brand' : 'Add New Brand' }}
          </h3>
          <div style="display: flex; align-items: center; gap: 8px;">
            <input type="checkbox" [(ngModel)]="newBrand.isActive" [disabled]="isSaving" id="isActive" class="brand-checkbox" style="margin: 0; cursor: pointer;">
            <label for="isActive" style="margin: 0; cursor: pointer; font-size: 0.9rem; font-weight: 600; color: #334155;">Active</label>
          </div>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label>Brand Name *</label>
            <input [(ngModel)]="newBrand.name" [disabled]="isSaving" placeholder="Enter Brand Name" class="form-input">
          </div>
          <div class="form-group full-width">
            <label>Description</label>
            <textarea [(ngModel)]="newBrand.description" [disabled]="isSaving" placeholder="Brand description..." class="form-input" rows="3"></textarea>
          </div>
        </div>

        <div class="modal-actions">
          <div *ngIf="errorMessage" class="error-message mr-auto">
            {{ errorMessage }}
          </div>
          <button *ngIf="editingId" class="secondary-btn" (click)="cancelEdit()" [disabled]="isSaving">Cancel</button>
          <button class="primary-btn" (click)="saveBrand()" [disabled]="isSaving">
            <span *ngIf="isSaving" class="spinner-small"></span>
            <span>{{ editingId ? 'Update Brand' : 'Add Brand' }}</span>
          </button>
        </div>
        
      </div>
    </div>

    <!-- Brand List Table -->
    <div class="table-container">
      <table class="ledger-table">
        <thead>
          <tr>
            <th class="sortable" (click)="onSort('name')">
              Brand Name <span *ngIf="sortColumn === 'name'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('description')">
              Description <span *ngIf="sortColumn === 'description'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center sortable" (click)="onSort('isActive')">
              Active <span *ngIf="sortColumn === 'isActive'" class="sort-icon">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let brand of brands">
            <td class="brand-name">{{ brand.name }}</td>
            <td class="text-secondary">{{ brand.description }}</td>
            <td class="text-center">
              <span class="status-badge" [class.active]="brand.isActive" [class.inactive]="!brand.isActive">
                {{ brand.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="text-center">
              <button class="icon-action-btn mr" (click)="editBrand(brand)" title="Edit">✏️</button>
              <button class="icon-action-btn" (click)="deleteBrand(brand.id)" title="Delete">🗑️</button>
            </td>
          </tr>
          
          <tr *ngIf="brands.length === 0">
            <td colspan="4" class="empty-state-large">
              No brands found. Add a new brand above.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
